<template>
  <v-layout row>
    <v-flex>
      <v-btn v-if="user && isCommunityJoined" dark fab right color="teal" slot="activator"
             @click="openChatDialog" style="bottom: 30px; right:10px; position: fixed; z-index: 1">
        <v-icon>add</v-icon>
      </v-btn>
      <v-card>
        <v-container fluid grid-list-md>
          <v-list two-line>
            <v-container>
              <template v-if="user">
                <v-subheader>My Chat</v-subheader>
                <div class="text-xs-center">
                  <v-progress-circular v-if="isMyChatLoading"
                                       :width="3" color="teal" indeterminate></v-progress-circular>
                  <span v-if="!isMyChatLoading && myChat.length === 0">
                  No chat, join us the following chat!
                </span>
                </div>
                <template v-for="(chat, index) in myChat">
                  <v-list-tile :key="chat.id" avatar @click="goToChatChat(chat.id)">
                    <v-list-tile-avatar>
                      <v-badge overlap color="orange">
                        <!--<v-icon v-if="chat.unread" dark small slot="badge">notifications</v-icon>-->
                        <v-icon v-if="chat.unread" dark small slot="badge">notifications</v-icon>
                        <v-avatar :color="chat.color + ' lighten-3 red--after'">
                          <img v-if="chat.icon" :src="chat.icon">
                          <v-icon v-else dark>fas fa-comments</v-icon>
                        </v-avatar>
                      </v-badge>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title>{{chat.name}}&nbsp;({{ chat.userCount }})</v-list-tile-title>
                      <v-list-tile-sub-title>{{ chat.purpose }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </template>

              <v-subheader>Public Chat</v-subheader>
              <div class="text-xs-center">
                <v-progress-circular v-if="isPublicChatLoading"
                                     :width="3" color="teal" indeterminate></v-progress-circular>
                <span v-if="!isPublicChatLoading && publicChat.length === 0">
                No chat, create new chat with sign-in!
              </span>
              </div>
              <template v-for="(chat, index) in publicChat">
                <v-list-tile :key="'Public-' + chat.id" avatar @click="goToChatChat(chat.id)">
                  <v-list-tile-avatar>
                    <v-avatar :color="chat.color + ' lighten-3 red--after'">
                      <img v-if="chat.icon" :src="chat.icon">
                      <v-icon v-else dark>fas fa-comments</v-icon>
                    </v-avatar>
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title>{{chat.name}}&nbsp;({{ chat.userCount }})</v-list-tile-title>
                    <v-list-tile-sub-title>{{ chat.purpose }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-container>
          </v-list>
        </v-container>

        <v-dialog v-model="chatDialog" fullscreen hide-overlay
                  transition="dialog-bottom-transition">
          <v-card>
            <v-toolbar dark color="teal">
              <v-btn icon dark @click="chatDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>New Chat</v-toolbar-title>
            </v-toolbar>
            <v-form>
              <v-container>
                <v-layout wrap>
                  <v-flex xs12 text-xs-center>
                    <v-checkbox v-model="isAutoGenerateChatId"
                                color="teal" label="Auto Generate Chat ID"></v-checkbox>
                    <v-text-field v-model="chatChatId"
                                  label="Chat ID" :disabled="isAutoGenerateChatId"></v-text-field>
                    <v-text-field v-model="chatChatName" label="Chat Name"></v-text-field>
                    <v-text-field v-model="purpose" label="Purpose"></v-text-field>

                    <v-autocomplete v-model="chatUsers" :disabled="isUpdating"
                                    :items="communityUsers"
                                    chips color="blue-grey lighten-3"
                                    label="Add Users" item-text="name" item-value="id" multiple>
                      <template slot="selection" slot-scope="data">
                        <v-chip v-if="user.uid === data.item.id"
                                :selected="data.selected" class="chip--select-multi">
                          <v-avatar><img :src="data.item.avatar"></v-avatar>{{ data.item.name }}
                        </v-chip>
                        <v-chip v-else :selected="data.selected" close class="chip--select-multi"
                                @input="removeChatUser(data.item)">
                          <v-avatar><img :src="data.item.avatar"></v-avatar>{{ data.item.name }}
                        </v-chip>
                      </template>
                      <template slot="item" slot-scope="data">
                        <v-list-tile-avatar>
                          <img :src="data.item.avatar">
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                        </v-list-tile-content>
                      </template>
                    </v-autocomplete>

                    <v-checkbox v-model="isPublic"
                                color="teal" label="Public - only for now" disabled></v-checkbox>

                    <v-btn :loading="isChatCreating" :disabled="isChatCreating"
                           color="teal white--text" @click="createChat()">
                      GO TO CHAT
                      <span slot="loader">Loading...</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card>
        </v-dialog>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'ChatSpace',
  props: {
    user: Object,
    communityUsers: Array,
    communityId: String,
    isCommunityJoined: Boolean,
    colors: Array,
    myChat: Array,
    isMyChatLoading: Boolean,
    publicChat: Array,
    isPublicChatLoading: Boolean,
  },
  data() {
    return {
      chatDialog: false,
      chatChatId: '',
      isAutoGenerateChatId: true,
      chatChatName: '',
      chatUsers: [],
      purpose: '',
      isPublic: true,
      isUpdating: false,
      isChatCreating: false,
    };
  },
  methods: {
    goToChatChat(chatId) {
      this.$router.push(`/c/${this.communityId}/chat/${chatId}`);
    },
    openChatDialog() {
      this.chatDialog = true;

      if (this.chatUsers.length === 0) {
        this.chatUsers.push(this.user.uid);
      }
    },
    removeChatUser(item) {
      const index = this.chatUsers.indexOf(item.id);
      if (index >= 0) this.chatUsers.splice(index, 1);
    },
    randomColor() {
      return this.colors[Math.floor(Math.random() * (this.colors.length))];
    },
    createChat() {
      this.isChatCreating = true;
      const currentTimestamp = firebase.firestore.FieldValue.serverTimestamp();
      const chat = {
        name: this.chatChatName,
        purpose: this.purpose,
        isPublic: this.isPublic,
        color: this.randomColor(),
        createdAt: currentTimestamp,
      };

      if (this.isAutoGenerateChatId) {
        firebase.firestore().collection(`communities/${this.communityId}/chat`).add(chat)
          .then((chatRef) => {
            chat.id = chatRef.id;
            chat.userCount = this.chatUsers.length;
            this.createChatUser(chatRef.id, currentTimestamp, () => this.$emit('createdChat', chat));
          })
          .catch(error => console.error(error));
      } else {
        firebase.firestore().collection(`communities/${this.communityId}/chat`).doc(this.chatChatId).set(chat)
          .then(() => {
            chat.id = this.chatChatId;
            chat.userCount = this.chatUsers.length;
            this.createChatUser(this.chatChatId, currentTimestamp, () => this.$emit('createdChat', chat));
          })
          .catch(error => console.error(error));
      }
    },
    createChatUser(chatId, timestamp, callback) {
      const batch = firebase.firestore().batch();

      this.chatUsers.forEach((user) => {
        const currentUserRef = firebase.firestore().doc(`users/${user}`);

        const chatUser = {
          userRef: currentUserRef,
          createdAt: timestamp,
        };

        if (user === this.user.uid) chatUser.owner = true;
        batch.set(firebase.firestore().doc(`communities/${this.communityId}/chat/${chatId}/users/${user}`), chatUser);

        batch.set(currentUserRef.collection('myChat').doc(chatId), {
          chatRef: firebase.firestore().doc(`communities/${this.communityId}/chat/${chatId}`),
          createdAt: timestamp,
        });
      });

      batch.commit().then(() => {
        if (callback) callback();
        this.$router.push(`/c/${this.communityId}/chat/${chatId}`);
      }).catch((error) => {
        console.error("Failure: chat isn't created.\n", error);
      });
    },
  },
};
</script>
